import { retrieveErrorFromApi } from '../../../helper'
import { setAdyenConnectedAccount, setPaymentStripeAccount, setPayPalNotification, setStripeNotification } from '../../action/payment'
import { setAppErrors } from '../../action/system'
import getAdyenConnectedAccount from '../../axios/payment/adyenConnectedAccounts/get'
import getStripeAccount from '../../axios/payment/stripeAccount/get'
import getPayPalNotification from '../../axios/payment/notification/get'
import updatePayPalNotification from '../../axios/payment/notification/put'

export const getStripeAccountThunk = () => dispatch => {
	return getStripeAccount()
		.then((res) => {
			dispatch(setPaymentStripeAccount(res.data))
		}).catch(() => {})
}

export const getPayPalNotificationThunk = () => dispatch => {
	return getPayPalNotification()
		.then((res) => {
			dispatch(setPayPalNotification(res.data))
		}).catch((error) => {
			if (error?.response?.data?.apierror?.status === 'NOT_FOUND')
				dispatch(setPayPalNotification({ newConditionsDeadlineWarningDisabled: false, newConditionsWarningDisabled: false }))
			else dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updatePayPalNotificationThunk = (data) => dispatch => {
	return updatePayPalNotification(data)
		.then((res) => {
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getStripeNotificationThunk = () => dispatch => {
	return getStripeAccount()
		.then((res) => {
			dispatch(setStripeNotification(res.data))
		}).catch(() => {})
}

export const getAdyenConnectedAccountThunk = () => dispatch => {
	return getAdyenConnectedAccount()
		.then((res) => {
			dispatch(setAdyenConnectedAccount(res.data?.[0] ?? null))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
